module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/qzj_user_privacy_new_4.png";